import { useMemo } from 'react';
import { DEFAULT_CLIENTS_QUERY_LIMIT } from 'src/graphql/entities/client';
import { prepareSortAttributes } from 'src/graphql/entities/custom-view/custom-view-config/utils';
import { CustomViewSorting } from 'src/graphql/entities/custom-view/custom-view.types';
import { useSearch } from 'src/graphql/entities/search/use-search';
import { ConditionInput, EntityNames } from 'src/graphql/types';
import { ClientAttributeAccessors, ClientAttributeType } from './constants';

// this hook abstracts the interface required for generic custom views table
export const useClientRecords = ({
  filters,
  sort,
  limit = DEFAULT_CLIENTS_QUERY_LIMIT,
  searchTerm,
  dynamicAttributePaths,
  includeDeleted,
}: {
  filters: ConditionInput[];
  sort?: CustomViewSorting;
  limit?: number;
  searchTerm?: string;
  dynamicAttributePaths?: string[];
  includeDeleted?: boolean;
}) => {
  const options = useMemo(() => {
    return {
      searchTerm: searchTerm ?? '',
      filter: filters,
      limit,
      sort: prepareSortAttributes<ClientAttributeType>(sort, ClientAttributeAccessors),
      entityName: EntityNames.Client,
      showResultsWhenEmptySearchTerm: true,
      dynamicAttributePaths,
      includeDeleted,
    };
  }, [filters, includeDeleted, limit, sort, searchTerm, dynamicAttributePaths]);

  const data = useSearch(options);

  if (!data) {
    throw new Error('Search is not configured to search for clients');
  }

  return data;
};
